function App() {
	return <div></div>;
}

export default App;
